import ErrorTemplate from '@/components/templates/ErrorTemplate/404ErrorTemplate'

const ErrorPage = () => {
  return <ErrorTemplate />
}

export default ErrorPage
